import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
declare var $:any;

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class ScriptsModule {

  public loadScript(url,section:string='head',id:string="")
  {
    console.log('loading section script...');
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';

    if (id == "true") {
      if(document.getElementById(section).appendChild(node)){
        console.log('done...');
      }
    }else{
      if(document.getElementsByTagName(section)[0].appendChild(node)){
        console.log('done...');
      }
    }
  }

  public deleteScript(src)
  {
    console.log('removing old section scripts');
    $('script').each(function(){
      if(this.src === src)
      {
        this.parentNode.removeChild( this );
        console.log('Script '+src+' removed');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/scripts.module.ts